import getters from "./getters";
export default {
  STAFF_UPDATEWEBSOCKET(state, websock) {
    state.websock = websock;
  },
  STAFF_UPDATECLIENID(state, clienId) {
    // console.log("clienId", clienId);
    state.clienId = clienId;
  },
  setWebsocketState(state, isConnect) {
    state.isConnect = isConnect;
  },
  sendMessage(state, { data }) {
    console.log("sendMessage", state.clienId);
    state.websock.send({
      data: JSON.stringify({ type: "whiteboard", data, to: state.clienId })
    });
  },
  clearWebsocket(state) {
    state.websock = null
    state.isConnect = false
  }
};
